import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getImageUrl } from "../../utils/imageUtils";
const SearchIcon = getImageUrl("search");

const SearchField = ({ search, setSearch, second_class }) => {
  const [localSearch, setLocalSearch] = useState(search || "");
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearch(localSearch);
    }, 500); // debounce delay in ms

    return () => clearTimeout(delayDebounce); // cleanup on each keystroke
  }, [localSearch, setSearch]);

  const setSearchValue = (e) => {
    setLocalSearch(e.target.value);
  };
  return (
    <div className={`${classes.search_field} ${second_class}`}>
      <img src={SearchIcon} alt="icon" className={classes.search_icon} />
      <input
        type="text"
        className={classes.search_area}
        placeholder="Search"
        value={localSearch}
        onChange={setSearchValue}
      />
    </div>
  );
};

SearchField.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  second_class: PropTypes.string,
};
export default SearchField;
